import axios from "axios";

const defaultState = {
  medias: []
};

export default {
  namespaced: true,

  state: {
    medias: [],
    mediaLoading: false
  },

  mutations: {
    setMedias(state, data) {
      state.medias = data;
    },

    setMediaLoading(state, isLoading) {
      state.mediaLoading = isLoading;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    fetchMedias({ commit, dispatch }) {
      return axios.get(process.env.VUE_APP_API_URL + 'media')
      .then(({ data }) => commit('setMedias', data || []))
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    deleteMedia({ commit, state }, mediaId) {
      return axios.delete(
        process.env.VUE_APP_API_URL + `media/${mediaId}`
      )
      .then(() => {
        let medias = [...state.medias];
        medias = medias.filter(media => mediaId !== media.id);
        commit('setMedias', medias);
      });
    },

    saveMedia({ commit, state }, newMedia) {
      return axios.post(process.env.VUE_APP_API_URL + 'media', newMedia)
      .then(({ data }) => {
        const medias = [...state.medias];
        medias.push(data);
        commit('setMedias', medias);
      });
    },

    updateMedia({ commit, state }, media) {
      return axios.put(process.env.VUE_APP_API_URL + 'media', media)
      .then(({ data }) => {
        let medias = [...state.medias];
        medias = medias.filter(m => m.id !== media.id);
        medias.push(data);
        commit('setMedias', medias);
      });
    }
  }
};